import type { FC } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger
} from '@ui/dialog.tsx';
import { Button } from '@ui/button.tsx';
import { TypologyForm } from './typology-form.tsx';
import type { TypologyTypologyReadModel } from '@r/api/generated/client.schemas.ts';

type Typology = TypologyTypologyReadModel;

interface CreateTypologyDialogProps {
  onSubmitSuccess: (typology: Typology) => void;
  useLocalState?: boolean;
  typologies?: Partial<Typology>[];
}

export const CreateTypologyDialog: FC<CreateTypologyDialogProps> = ({
  onSubmitSuccess,
  useLocalState,
  typologies
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleSubmitSuccess = (typology: Typology) => {
    onSubmitSuccess(typology);
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button rounded="full">{t('admin.typologies.creation.button')}</Button>
      </DialogTrigger>

      <DialogContent className="p-10 !rounded-3xl">
        <DialogHeader>
          <DialogTitle className="text-2xl">
            {t('admin.typology.creation.dialog.title')}
          </DialogTitle>

          <DialogDescription>{t('admin.typology.creation.dialog.description')}</DialogDescription>
        </DialogHeader>

        <TypologyForm
          onSubmitSuccess={handleSubmitSuccess}
          useLocalState={useLocalState}
          typologies={typologies}
        />
      </DialogContent>
    </Dialog>
  );
};
